import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CreditDetail from './credit-detail';
import Credits from './credits';

const NewCredit = () => {
    const search = useLocation().search;
    const merchantId = new URLSearchParams(search).get('merchant');
    return(
        (merchantId)?<CreditDetail />:<Credits />
    )
}

export default NewCredit;